import { createClient } from "@supabase/supabase-js";

// Note: These environment variables are automatically injected by Lovable
const supabaseUrl = "https://yqvwshyrufzkckflkdyp.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxdndzaHlydWZ6a2NrZmxrZHlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM4NjI3MDYsImV4cCI6MjA1OTQzODcwNn0.J81B2WvoPqyjONgj77KMQYIXD0bLnlY7y9I_biV_d50";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
